import React from 'react';
import { Mail, Send, MessageCircle, Phone } from 'lucide-react';
import { useStoreSettings } from '../lib/useStoreSettings';

const Item = ({ href, icon: Icon, label, value, testid, external }) => (
  <a href={href} data-testid={testid} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    className="group flex items-center gap-4 rounded-xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-[#141416] px-5 py-4 hover:border-brand hover:-translate-y-0.5 hover:shadow-lg transition-[transform,box-shadow,border-color] duration-200">
    <span className="grid place-items-center w-11 h-11 rounded-full bg-brand-soft text-brand group-hover:bg-brand group-hover:text-white transition-colors"><Icon size={18} /></span>
    <span className="min-w-0">
      <span className="block text-[11px] uppercase tracking-[0.2em] text-neutral-500">{label}</span>
      <span className="block text-[15px] font-medium text-neutral-900 dark:text-neutral-100 truncate">{value}</span>
    </span>
  </a>
);

const ContactCard = () => {
  const s = useStoreSettings();
  if (!s) return null;
  const wa = (s.whatsapp || '').replace(/[^0-9]/g, '');
  const tel = (s.phone || '').replace(/[^0-9+]/g, '');
  const items = [
    s.support_email && <Item key="e" href={`mailto:${s.support_email}`} icon={Mail} label="Email" value={s.support_email} testid="contact-card-email" />,
    s.telegram && <Item key="t" href={`https://t.me/${s.telegram}`} icon={Send} label="Telegram" value={`@${s.telegram}`} testid="contact-card-telegram" external />,
    wa && <Item key="w" href={`https://wa.me/${wa}`} icon={MessageCircle} label="WhatsApp" value={s.whatsapp} testid="contact-card-whatsapp" external />,
    tel && <Item key="p" href={`tel:${tel}`} icon={Phone} label="Phone" value={s.phone} testid="contact-card-phone" />,
  ].filter(Boolean);
  if (!items.length) return null;
  return <div data-testid="contact-card" className="mt-10 grid gap-3 sm:grid-cols-2">{items}</div>;
};

export default ContactCard;
